import { createUseStyles } from "react-jss";
const useStyles = createUseStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    WebkitBoxPack: "end",
    alignItems: "flex-end",
  },
  questionBubble: {
    background: theme.questionBubbleBg,
    borderRadius: "10px 10px 0 10px",
    color: theme.questionBubbleColor,
    display: "inline-block",
    maxWidth: "70%",
    overflow: "hidden",
    position: "relative",
    padding: "16px",
    textAlign: "right",
    fontSize: theme.messageFontSize,
    transformOrigin: "bottom right",
  },
  seenBox: {
    display: "flex",
    alignItems: "center",
  },
  rtlDirection: {
    direction: "rtl !important",
    textAlign: "right",
  },
  ltrDirection: {
    direction: "ltr !important",
    textAlign: "left",
  },
  time: {
    fontSize: 14,
    color: theme.chatTimeColor,
    marginInline: 4,
  },
}));
export { useStyles };
